import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class HazardZone {
    constructor(doc)
    {
		this.label = null
		this.hazardZoneType = null
		this.hazardZoneTypeOtherDescription = null
		this.lavaFlowZoneCode = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.hazardZoneType = x.getStringElement(doc, "./ns:HazardZoneType");
		this.hazardZoneTypeOtherDescription = x.getStringElement(doc, "./ns:HazardZoneTypeOtherDescription");
		this.lavaFlowZoneCode = x.getStringElement(doc, "./ns:LavaFlowZoneCode");
   }

	 GetHazardType() {
		return h.descriptionOrOther(this.hazardZoneType, this.hazardZoneTypeOtherDescription);
	 }
}

export class HighestAndBestUse {
    constructor(doc)
    {
		this.label = null
		this.financiallyFeasibleIndicator = null
		this.legallyPermissibleIndicator = null
		this.maximallyProductiveIndicator = null
		this.physicallyPossibleIndicator = null
		this.siteHighestBestUseIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.financiallyFeasibleIndicator = x.getBooleanElement(doc, "./ns:FinanciallyFeasibleIndicator");
		this.legallyPermissibleIndicator = x.getBooleanElement(doc, "./ns:LegallyPermissibleIndicator");
		this.maximallyProductiveIndicator = x.getBooleanElement(doc, "./ns:MaximallyProductiveIndicator");
		this.physicallyPossibleIndicator = x.getBooleanElement(doc, "./ns:PhysicallyPossibleIndicator");
		this.siteHighestBestUseIndicator = x.getBooleanElement(doc, "./ns:SiteHighestBestUseIndicator");
   }
}

export class AccessStreet {
    constructor(doc)
    {
		this.label = null
		this.improvedSurfaceMaterialType = null
		this.improvedSurfaceMaterialTypeOtherDescription = null
		this.streetAccessType = null
		this.streetAccessTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.improvedSurfaceMaterialType = x.getStringElement(doc, "./ns:ImprovedSurfaceMaterialType");
		this.improvedSurfaceMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:ImprovedSurfaceMaterialTypeOtherDescription");
		this.streetAccessType = x.getStringElement(doc, "./ns:StreetAccessType");
		this.streetAccessTypeOtherDescription = x.getStringElement(doc, "./ns:StreetAccessTypeOtherDescription");
  }

	GetStreetAccessType()	{
			return h.descriptionOrOther(this.streetAccessType, this.streetAccessTypeOtherDescription);
	}
	GetSurfaceMaterialType() {
			return h.descriptionOrOther(this.improvedSurfaceMaterialType, this.improvedSurfaceMaterialTypeOtherDescription);
	}

}

export class PropertyAccessDetail {
    constructor(doc)
    {
		this.label = null
		this.privateStreetMaintenanceAgreementExistIndicator = null
		this.propertyAccessDescription = null
		this.propertyAccessTypicalToMarketIndicator = null
		this.propertyPrimaryEntryExitMethodType = null
		this.propertyPrimaryEntryExitMethodTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.privateStreetMaintenanceAgreementExistIndicator = x.getBooleanElement(doc, "./ns:PrivateStreetMaintenanceAgreementExistIndicator");
		this.propertyAccessDescription = x.getStringElement(doc, "./ns:PropertyAccessDescription");
		this.propertyAccessTypicalToMarketIndicator = x.getBooleanElement(doc, "./ns:PropertyAccessTypicalToMarketIndicator");
		this.propertyPrimaryEntryExitMethodType = x.getStringElement(doc, "./ns:PropertyPrimaryEntryExitMethodType");
		this.propertyPrimaryEntryExitMethodTypeOtherDescription = x.getStringElement(doc, "./ns:PropertyPrimaryEntryExitMethodTypeOtherDescription");
   }
}

export class PropertyAccess {
    constructor(doc)
    {
		this.label = null
		this.accessStreets = []
		this.propertyAccessDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:ACCESS_STREETS/ns:ACCESS_STREET");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.accessStreets.push(new AccessStreet(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:PROPERTY_ACCESS_DETAIL");
		if (node !== null)
				this.propertyAccessDetail = new PropertyAccessDetail(node);
  }

	GetStreetTypeAndSurface()
	{
			var types = [];
			for ( var street of this.accessStreets)
			{
					var type = street.GetStreetAccessType();
					types.push(h.addWithSpacer(type, street.GetSurfaceMaterialType()));
			}
			return types;
	}

	GetPrimaryEntryExitMethod()
	{
		return h.descriptionOrOther(this.propertyAccessDetail.propertyPrimaryEntryExitMethodType, this.propertyAccessDetail.propertyPrimaryEntryExitMethodTypeOtherDescription);
	}

}

export class SiteDetail {
    constructor(doc)
    {
		this.label = null
		this.broadbandInternetAvailableIndicator = null
		this.landOwnedInCommonIndicator = null
		this.publicSewerUtilityAvailableNotConnectedIndicator = null
		this.publicWaterUtilityAvailableNotConnectedIndicator = null
		this.siteDefectsExistIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.landOwnedInCommonIndicator = x.getBooleanElement(doc, "./ns:LandOwnedInCommonIndicator");
		this.broadbandInternetAvailableIndicator = x.getBooleanElement(doc, "./ns:BroadbandInternetAvailableIndicator");
		this.publicSewerUtilityAvailableNotConnectedIndicator = x.getBooleanElement(doc, "./ns:PublicSewerUtilityAvailableNotConnectedIndicator");
		this.publicWaterUtilityAvailableNotConnectedIndicator = x.getBooleanElement(doc, "./ns:PublicWaterUtilityAvailableNotConnectedIndicator");
		this.siteDefectsExistIndicator = x.getBooleanElement(doc, "./ns:SiteDefectsExistIndicator");
   }
}

export class DrainageImpactReason {
    constructor(doc)
    {
		this.label = null
		this.siteDrainageReasonType = null
		this.siteDrainageReasonTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.siteDrainageReasonType = x.getStringElement(doc, "./ns:SiteDrainageReasonType");
		this.siteDrainageReasonTypeOtherDescription = x.getStringElement(doc, "./ns:SiteDrainageReasonTypeOtherDescription");
   }
}

export class SiteFeatureDetail {
    constructor(doc)
    {
		this.label = null
		this.siteFeatureDescription = null
		this.siteFeatureType = null
		this.siteFeatureTypeOtherDescription = null
		this.valueMarketabilityImpactType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.siteFeatureDescription = x.getStringElement(doc, "./ns:SiteFeatureDescription");
		this.siteFeatureType = x.getStringElement(doc, "./ns:SiteFeatureType");
		this.siteFeatureTypeOtherDescription = x.getStringElement(doc, "./ns:SiteFeatureTypeOtherDescription");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }
}

export class Topography {
    constructor(doc)
    {
		this.label = null
		this.topographyType = null
		this.topographyTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.topographyType = x.getStringElement(doc, "./ns:TopographyType");
		this.topographyTypeOtherDescription = x.getStringElement(doc, "./ns:TopographyTypeOtherDescription");
   }
}

export class SiteFeature {
    constructor(doc)
    {
		this.label = null
		this.drainageImpactReasons = []
		this.siteFeatureDetail = null
		this.topographies = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:DRAINAGE_IMPACT_REASONS/ns:DRAINAGE_IMPACT_REASON");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.drainageImpactReasons.push(new DrainageImpactReason(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:SITE_FEATURE_DETAIL");
		if (node !== null)
				this.siteFeatureDetail = new SiteFeatureDetail(node);
		nodes = x.selectNodes(doc, "./ns:TOPOGRAPHIES/ns:TOPOGRAPHY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.topographies.push(new Topography(xn));
			});
		}
   }

	 GetFeatureType() {
		return h.descriptionOrOther(this.siteFeatureDetail.siteFeatureType, this.siteFeatureDetail.siteFeatureTypeOtherDescription);
	 }

	 GetDescription() {
		return this.siteFeatureDetail.siteFeatureDescription;
	 }
}

export class AirportZone {
    constructor(doc)
    {
		this.label = null
		this.specialAirportHazardZoneType = null
		this.specialAirportHazardZoneTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.specialAirportHazardZoneType = x.getStringElement(doc, "./ns:SpecialAirportHazardZoneType");
		this.specialAirportHazardZoneTypeOtherDescription = x.getStringElement(doc, "./ns:SpecialAirportHazardZoneTypeOtherDescription");
   }
}

export class BodyOfWater {
    constructor(doc)
    {
		this.label = null
		this.bodyOfWaterDescription = null
		this.bodyOfWaterName = null
		this.bodyOfWaterProximityType = null
		this.bodyOfWaterType = null
		this.bodyOfWaterTypeOtherDescription = null
		this.privateAccessIndicator = null
		this.valueMarketabilityImpactType = null
		this.waterAccessDepthType = null
		this.waterAccessDepthTypeOtherDescription = null
		this.waterAccessRightType = null
		this.waterAccessRightTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.bodyOfWaterDescription = x.getStringElement(doc, "./ns:BodyOfWaterDescription");
		this.bodyOfWaterName = x.getStringElement(doc, "./ns:BodyOfWaterName");
		this.bodyOfWaterProximityType = x.getStringElement(doc, "./ns:BodyOfWaterProximityType");
		this.bodyOfWaterType = x.getStringElement(doc, "./ns:BodyOfWaterType");
		this.bodyOfWaterTypeOtherDescription = x.getStringElement(doc, "./ns:BodyOfWaterTypeOtherDescription");
		this.privateAccessIndicator = x.getBooleanElement(doc, "./ns:PrivateAccessIndicator");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
		this.waterAccessDepthType = x.getStringElement(doc, "./ns:WaterAccessDepthType");
		this.waterAccessDepthTypeOtherDescription = x.getStringElement(doc, "./ns:WaterAccessDepthTypeOtherDescription");
		this.waterAccessRightType = x.getStringElement(doc, "./ns:WaterAccessRightType");
		this.waterAccessRightTypeOtherDescription = x.getStringElement(doc, "./ns:WaterAccessRightTypeOtherDescription");
   }

	 GetBodyType() {
		return h.descriptionOrOther(this.bodyOfWaterType , this.bodyOfWaterTypeOtherDescription);
	 }

	 GetAccessType() {
		return h.descriptionOrOther(this.waterAccessRightType , this.waterAccessRightTypeOtherDescription);
	 }

	 GetDepthType() {
		return h.descriptionOrOther(this.waterAccessDepthType , this.waterAccessDepthTypeOtherDescription);
	 }
}

export class WaterFrontFeature {
    constructor(doc)
    {
		this.label = null
		this.waterfrontFeatureType = null
		this.waterfrontFeatureTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.waterfrontFeatureType = x.getStringElement(doc, "./ns:WaterfrontFeatureType");
		this.waterfrontFeatureTypeOtherDescription = x.getStringElement(doc, "./ns:WaterfrontFeatureTypeOtherDescription");
   }

	GetFeatureType() {
		return h.descriptionOrOther(this.waterfrontFeatureType , this.waterfrontFeatureTypeOtherDescription);
	}

}

export class BodiesOfWater {
    constructor(doc)
    {
		this.label = null
		this.bodyOfWaterList = []
		this.waterFrontFeatures = []
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:BODY_OF_WATER");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.bodyOfWaterList.push(new BodyOfWater(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:WATER_FRONT_FEATURES/ns:WATER_FRONT_FEATURE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.waterFrontFeatures.push(new WaterFrontFeature(xn));
			});
		}
   }
}

export class SiteInfluenceDetail {
    constructor(doc)
    {
		this.label = null
		this.influenceMeetsPolicyRequirementsIndicator = null
		this.siteInfluenceDescription = null
		this.siteInfluenceProximityType = null
		this.siteInfluenceType = null
		this.siteInfluenceTypeOtherDescription = null
		this.valueMarketabilityImpactType = null
		this.waterFrontageTotalLengthLinearMeasure = null
		this.waterfrontDevelopmentRightsIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.influenceMeetsPolicyRequirementsIndicator = x.getBooleanElement(doc, "./ns:InfluenceMeetsPolicyRequirementsIndicator");
		this.siteInfluenceDescription = x.getStringElement(doc, "./ns:SiteInfluenceDescription");
		this.siteInfluenceProximityType = x.getStringElement(doc, "./ns:SiteInfluenceProximityType");
		this.siteInfluenceType = x.getStringElement(doc, "./ns:SiteInfluenceType");
		this.siteInfluenceTypeOtherDescription = x.getStringElement(doc, "./ns:SiteInfluenceTypeOtherDescription");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
		this.waterFrontageTotalLengthLinearMeasure = x.getMISMOMeasureElement(doc, "./ns:WaterFrontageTotalLengthLinearMeasure");
		this.waterfrontDevelopmentRightsIndicator = x.getBooleanElement(doc, "./ns:WaterfrontDevelopmentRightsIndicator");
   }
}

export class SiteInfluence {
    constructor(doc)
    {
		this.label = null
		this.airportZones = []
		this.bodiesOfWater = null
		this.siteInfluenceDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:AIRPORT_ZONES/ns:AIRPORT_ZONE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.airportZones.push(new AirportZone(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:BODIES_OF_WATER");
		if (node !== null)
				this.bodiesOfWater = new BodiesOfWater(node);
		node = x.selectSingleNode(doc, "./ns:SITE_INFLUENCE_DETAIL");
		if (node !== null)
				this.siteInfluenceDetail = new SiteInfluenceDetail(node);
   }

	GetInfluence() {
		var influence = "";
		if (this.siteInfluenceDetail.siteInfluenceType === "BodyOfWater") {
				if (this.bodiesOfWater !== null)
						for (var bow of this.bodiesOfWater.bodyOfWaterList)
								influence = h.addWithSpacer(influence, bow.GetBodyType());
			}
		else
				influence = this.GetInfluenceType();
		return influence;
	}

	GetInfluenceType() {
			return h.descriptionOrOther(this.siteInfluenceDetail.siteInfluenceType, this.siteInfluenceDetail.siteInfluenceTypeOtherDescription);
	}

	GetProximityType() {
			return h.descriptionOrOther(this.siteInfluenceDetail.siteInfluenceProximityType, this.siteInfluenceDetail.siteInfluenceTypeOtherDescription);
	}

}

export class SiteSizeLayout {
    constructor(doc)
    {
		this.label = null
		this.lotSizeAreaMeasure = null
		this.parcelCount = null
		this.parcelsContiguousIndicator = null
		this.siteDimensionsDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.lotSizeAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:LotSizeAreaMeasure");
		this.parcelCount = x.getIntegerElement(doc, "./ns:ParcelCount");
		this.parcelsContiguousIndicator = x.getBooleanElement(doc, "./ns:ParcelsContiguousIndicator");
		this.siteDimensionsDescription = x.getStringElement(doc, "./ns:SiteDimensionsDescription");
   }
}

export class SiteUtilityDetail {
    constructor(doc)
    {
		this.label = null
		this.siteUtilityDescription = null
		this.siteUtilityOwnershipType = null
		this.utilityType = null
		this.utilityTypeOtherDescription = null
		this.valueMarketabilityImpactType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.siteUtilityDescription = x.getStringElement(doc, "./ns:SiteUtilityDescription");
		this.siteUtilityOwnershipType = x.getStringElement(doc, "./ns:SiteUtilityOwnershipType");
		this.utilityType = x.getStringElement(doc, "./ns:UtilityType");
		this.utilityTypeOtherDescription = x.getStringElement(doc, "./ns:UtilityTypeOtherDescription");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }
}

export class SiteUtilityService {
    constructor(doc)
    {
		this.label = null
		this.electricitySourceType = null
		this.electricitySourceTypeOtherDescription = null
		this.sewerSystemType = null
		this.sewerSystemTypeOtherDescription = null
		this.utilityMeetsDistanceRequirementIndicator = null
		this.utilitySharedIndicator = null
		this.waterSourceType = null
		this.waterSourceTypeOtherDescription = null
		this.waterWellType = null
		this.waterWellTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.electricitySourceType = x.getStringElement(doc, "./ns:ElectricitySourceType");
		this.electricitySourceTypeOtherDescription = x.getStringElement(doc, "./ns:ElectricitySourceTypeOtherDescription");
		this.sewerSystemType = x.getStringElement(doc, "./ns:SewerSystemType");
		this.sewerSystemTypeOtherDescription = x.getStringElement(doc, "./ns:SewerSystemTypeOtherDescription");
		this.utilityMeetsDistanceRequirementIndicator = x.getBooleanElement(doc, "./ns:UtilityMeetsDistanceRequirementIndicator");
		this.utilitySharedIndicator = x.getBooleanElement(doc, "./ns:UtilitySharedIndicator");
		this.waterSourceType = x.getStringElement(doc, "./ns:WaterSourceType");
		this.waterSourceTypeOtherDescription = x.getStringElement(doc, "./ns:WaterSourceTypeOtherDescription");
		this.waterWellType = x.getStringElement(doc, "./ns:WaterWellType");
		this.waterWellTypeOtherDescription = x.getStringElement(doc, "./ns:WaterWellTypeOtherDescription");
   }
}

export class SiteUtility {
	constructor(doc)
	{
		this.label = null
		this.siteUtilityDetail = null
		this.siteUtilityServices = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:SITE_UTILITY_DETAIL");
		if (node !== null)
				this.siteUtilityDetail = new SiteUtilityDetail(node);
		nodes = x.selectNodes(doc, "./ns:SITE_UTILITY_SERVICES/ns:SITE_UTILITY_SERVICE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.siteUtilityServices.push(new SiteUtilityService(xn));
			});
		}
	}

	GetUtilityType()
	{
		return h.descriptionOrOther(this.siteUtilityDetail.utilityType, this.siteUtilityDetail.utilityTypeOtherDescription);
	}

	IsPublic() {
		return (this.siteUtilityDetail.siteUtilityOwnershipType === "Public");
	}

	IsShared() {
		if (this.siteUtilityServices.length === 0) return false;
		return (this.siteUtilityServices[0].utilitySharedIndicator ?? false);
	}

	IsPrivate() {
		return this.siteUtilityDetail.siteUtilityOwnershipType === "Private" || this.siteUtilityDetail.siteUtilityOwnershipType === "NonPublic"; 
	}


 GetDetail() {
			var source = "";
			if (this.siteUtilityServices.length === 0) return source;

			var bNotConnected = false;
			var govtAgencyAppraisalType = global.ptr.sowDetail.GovernmentAgencyAppraisalType;

			var type = this.siteUtilityDetail.utilityType;
			var services = this.siteUtilityServices[0];
			var isShared = this.IsShared();
			if (type === "Electricity")
			{
					source = h.descriptionOrOther(services.electricitySourceType, services.electricitySourceTypeOtherDescription);
					if (isShared) source = source + " (Shared)";
			}
			else if (type === "Gas")
			{
					if (isShared) source = source + "(Shared)";
			}
			else if (type === "SanitarySewer")
			{
					source = h.descriptionOrOther(services.sewerSystemType, services.sewerSystemTypeOtherDescription);
					if (isShared) source += " (Shared)";
			}
			else if (type === "Water")
			{
					source = h.descriptionOrOther(services.waterSourceType, services.waterSourceTypeOtherDescription);
					if (global.ptr.bGovtAgency && services.waterSourceType === "Well")
					{
							var wellType = h.descriptionOrOther(services.waterWellType, services.waterWellTypeOtherDescription);
							source = h.addWithSpacer(source, wellType, "-");
							if (services.utilityMeetsDistanceRequirementIndicator ?? false)
									source += "\nWell meets distance requirements";
							else
									source += "\nWell does not meet distance requirements";

							if (govtAgencyAppraisalType === "FHA" && bNotConnected)
									source += "\nPublic water available not connected";
							else
									source += "\nPublic water not available";
					}
					else
							if (isShared) source = source + " (Shared)";
			}
			else
					source = type;

			return source;
	}

}

export class SiteView {
    constructor(doc)
    {
		this.label = null
		this.valueMarketabilityImpactType = null
		this.viewPrimaryIndicator = null
		this.viewRangeType = null
		this.viewRangeTypeOtherDescription = null
		this.viewType = null
		this.viewTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
		this.viewPrimaryIndicator = x.getBooleanElement(doc, "./ns:ViewPrimaryIndicator");
		this.viewRangeType = x.getStringElement(doc, "./ns:ViewRangeType");
		this.viewRangeTypeOtherDescription = x.getStringElement(doc, "./ns:ViewRangeTypeOtherDescription");
		this.viewType = x.getStringElement(doc, "./ns:ViewType");
		this.viewTypeOtherDescription = x.getStringElement(doc, "./ns:ViewTypeOtherDescription");
  }

	GetViewType(numViews) {
		var view = h.descriptionOrOther(this.viewType, this.viewTypeOtherDescription);
		if (numViews > 1 && (this.viewPrimaryIndicator ?? false)) view = view + " (Primary)";
		return view;
	}

	GetViewRange() {
		return h.descriptionOrOther(this.viewRangeType, this.viewRangeTypeOtherDescription);
	}

}

export class SiteZoningDetail {
    constructor(doc)
    {
		this.label = null
		this.siteZoningClassificationDescription = null
		this.siteZoningClassificationIdentifier = null
		this.siteZoningComplianceDescription = null
		this.siteZoningComplianceType = null
		this.zoningPermitRebuildToCurrentDensityIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.siteZoningClassificationDescription = x.getStringElement(doc, "./ns:SiteZoningClassificationDescription");
		this.siteZoningClassificationIdentifier = x.getStringElement(doc, "./ns:SiteZoningClassificationIdentifier");
		this.siteZoningComplianceDescription = x.getStringElement(doc, "./ns:SiteZoningComplianceDescription");
		this.siteZoningComplianceType = x.getStringElement(doc, "./ns:SiteZoningComplianceType");
		this.zoningPermitRebuildToCurrentDensityIndicator = x.getBooleanElement(doc, "./ns:ZoningPermitRebuildToCurrentDensityIndicator");
   }
}

export class ZoningIllegalReason {
    constructor(doc)
    {
		this.label = null
		this.siteZoningComplianceIllegalReasonType = null
		this.siteZoningComplianceIllegalReasonTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.siteZoningComplianceIllegalReasonType = x.getStringElement(doc, "./ns:SiteZoningComplianceIllegalReasonType");
		this.siteZoningComplianceIllegalReasonTypeOtherDescription = x.getStringElement(doc, "./ns:SiteZoningComplianceIllegalReasonTypeOtherDescription");
   }
}

export class SiteZoning {
    constructor(doc)
    {
		this.label = null
		this.siteZoningDetail = null
		this.zoningIllegalReasons = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:SITE_ZONING_DETAIL");
		if (node !== null)
				this.siteZoningDetail = new SiteZoningDetail(node);
		nodes = x.selectNodes(doc, "./ns:ZONING_ILLEGAL_REASONS/ns:ZONING_ILLEGAL_REASON");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.zoningIllegalReasons.push(new ZoningIllegalReason(xn));
			});
		}
   }

	 GetIllegalReasons() {
			var reasons = "";
			for (var reason of this.zoningIllegalReasons)
					reasons = h.addWithSpacer(reasons, h.descriptionOrOther(reason.siteZoningComplianceIllegalReasonType, reason.siteZoningComplianceIllegalReasonTypeOtherDescription));
			return reasons;

	 }
}

export class Site {
    constructor(doc)
    {
		this.label = null
		this.hazardZones = []
		this.highestAndBestUse = null
		this.propertyAccess = null
		this.siteDetail = null
		this.siteFeatures = []
		this.siteInfluences = []
		this.siteSizeLayout = null
		this.siteUtilities = []
		this.siteViews = []
		this.siteZoning = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:HAZARD_ZONES/ns:HAZARD_ZONE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.hazardZones.push(new HazardZone(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:HIGHEST_AND_BEST_USE");
		if (node !== null)
				this.highestAndBestUse = new HighestAndBestUse(node);
		node = x.selectSingleNode(doc, "./ns:PROPERTY_ACCESS");
		if (node !== null)
				this.propertyAccess = new PropertyAccess(node);
		node = x.selectSingleNode(doc, "./ns:SITE_DETAIL");
		if (node !== null)
				this.siteDetail = new SiteDetail(node);
		nodes = x.selectNodes(doc, "./ns:SITE_FEATURES/ns:SITE_FEATURE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.siteFeatures.push(new SiteFeature(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:SITE_INFLUENCES/ns:SITE_INFLUENCE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.siteInfluences.push(new SiteInfluence(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:SITE_SIZE_LAYOUT");
		if (node !== null)
				this.siteSizeLayout = new SiteSizeLayout(node);
		nodes = x.selectNodes(doc, "./ns:SITE_UTILITIES/ns:SITE_UTILITY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.siteUtilities.push(new SiteUtility(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:SITE_VIEWS/ns:SITE_VIEW");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.siteViews.push(new SiteView(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:SITE_ZONING");
		if (node !== null)
				this.siteZoning = new SiteZoning(node);
   }

	GetWaterFrontageTotalLinearMeasurement() {
		var total = 0;
		//console.log(this.siteInfluences);
		if (this.siteInfluences.length === 0) return undefined;
		for (var influence of this.siteInfluences)
			if (influence.bodiesOfWater)
				for (var bow of influence.bodiesOfWater.bodyOfWaterList)
						if (bow.privateAccessIndicator ?? false)
							total += influence.siteInfluenceDetail.waterFrontageTotalLengthLinearMeasure.GetValue();
		if (total > 0) return total.toString() + " Ft.";
		return undefined;
	}

	GetPrivateAccess() {
		var pa = [];
		if (this.siteInfluences.length === 0) return pa;
		for (var influence of this.siteInfluences)
			if (influence.siteInfluenceDetail.siteInfluenceType === "BodyOfWater")
					for (var bow of influence.bodiesOfWater.bodyOfWaterList)
						if (bow.privateAccessIndicator ?? false)
               pa.push(influence);
		return pa;
	}

	GetWaterFrontFeatures() {
		var wfflist = [];
		var pa = this.GetPrivateAccess();
		if (pa.length === 0) return wfflist;
		for (var inf of pa) {
			for(var wff of inf.bodiesOfWater.waterFrontFeatures)
				wfflist.push(wff.GetFeatureType());
		}
		return wfflist;
	}

	HasWaterFrontFeatures() {
		if (this.siteInfluences.length === 0) return false;
		for (var influence of this.siteInfluences)
			if (influence.siteInfluenceDetail.siteInfluenceType === "BodyOfWater")
				if (influence.siteInfluenceDetail.privateAccessIndicator)
					return true;
		return false;
	}

	GetHazardZones() {
			let list = '';
			if (!this.hazardZones || this.hazardZones.length === 0) return list;
			for (const hz of this.hazardZones) {
					let zone = '';
					if (hz.hazardZoneType === "USGSLavaFlowZone") {
							zone = "USGS Lava Flow ";
							zone += h.toEnumText(hz.lavaFlowZoneCode);
					} else {
							zone = hz.GetHazardType();
					}
					list = h.addWithSpacer(list, zone);
			}
			return list;
	}

	GetTopography() {
			let topo = '';
			if (!this.siteFeatures) return topo;
			for (const sf of this.siteFeatures) {
					if (sf.siteFeatureDetail.siteFeatureType === "Topography") {
							for (const t of sf.topographies) {
									topo = h.addWithSpacer(topo, h.descriptionOrOther(t.topographyType, t.topographyTypeOtherDescription));
							}
					}
			}
			return topo;
	}

	GetDrainage() {
			let list = '';
			if (!this.siteFeatures) return list;
			for (const sf of this.siteFeatures) {
					if (sf.siteFeatureDetail.siteFeatureType === "Drainage") {
							list = h.addWithSpacer(list, sf.GetFeatureType());
					}
			}
			return list;
	}

	GetSiteCharacteristics() {
			let list = '';
			if (!this.siteFeatures) return list;
			for (const sf of this.siteFeatures) {
					if (sf.siteFeatureDetail.siteFeatureType !== "Drainage" && sf.siteFeatureDetail.siteFeatureType !== "Topography") {
							list = h.addWithSpacer(list, sf.GetFeatureType());
					}
			}
			return list;
	}

	GetFeatures() {
			const list = [];
			if (!this.siteFeatures) return list;
			for (const sf of this.siteFeatures) {
					list.push(sf);
			}
			return list;
	}

	GetInfluence() {
			let influence = '';
			if (this.siteInfluences.length === 0) return influence;
			for (const si of this.siteInfluences) {
					influence = h.addWithSpacer(influence, si.GetInfluence());
			}
			return influence;
	}

	GetViewRange() {
			let view = '';
			for (const sv of this.siteViews) {
					view = h.addWithNewline(view, h.descriptionOrOther(sv.viewType, sv.viewTypeOtherDescription));
					view = h.addWithSpacer(view, h.descriptionOrOther(sv.viewRangeType, sv.viewRangeTypeOtherDescription));
			}
			return view;
	}

	GetView() {
			let view = '';
			for (const sv of this.siteViews) {
					view = h.addWithSpacer(view, h.descriptionOrOther(sv.viewType, sv.viewRangeTypeOtherDescription));
			}
			return view;
	}

	GetEntryExitType() {
			if (!this.propertyAccess) return null;
			if (!this.propertyAccess.propertyAccessDetail) return null;
			return h.descriptionOrOther(this.propertyAccess.propertyAccessDetail.propertyPrimaryEntryExitMethodType,
					this.propertyAccess.propertyAccessDetail.propertyPrimaryEntryExitMethodTypeOtherDescription);
	}

	GetStreetAccessTypes() {
			let list = '';
			if (!this.propertyAccess) return null;
			if (!this.propertyAccess.AccessStreets) return null;
			for (const a of this.propertyAccess.AccessStreets) {
					let ts = a.GetStreetAccessType();
					ts = h.addWithSpacer(ts, a.improvedSurfaceMaterialType);
					list = h.addWithSpacer(list, ts);
			}
			return list;
	}

	GetSitePrivateWaterAccess() {
			for (const si of this.siteInfluences) {
					if (si.bodiesOfWater) {
							for (const bow of si.bodiesOfWater.bodyOfWaterList) {
									if (bow.privateAccessIndicator ?? false) return true;
							}
					}
			}
			return false;
	}

	GetBodiesOfWaterDetails() {
			let details = '';
			for (const si of this.siteInfluences) {
					if (si.bodiesOfWater) {
							for (const bow of si.bodiesOfWater.bodyOfWaterList) {
									if (bow.privateAccessIndicator ?? false) {
											// Continue with the rest of the implementation
									}
							}
					}
			}
			return details;
	}

}

